import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@snack-uikit/tooltip';
export function useButtonWithTooltip({ Button, tooltip, }) {
    if (tooltip) {
        return function ButtonWithTooltip(props) {
            return (_jsx(Tooltip, Object.assign({}, tooltip, { children: _jsx(Button, Object.assign({}, props)) })));
        };
    }
    return Button;
}
